import React, { Component } from 'react';
import $ from 'jquery';
import { Switch } from 'antd';
import _ from 'lodash';
import hash from 'object-hash';
import InfiniteScroll from 'react-infinite-scroller';
import qs from 'query-string';
import { __ } from '@wordpress/i18n';

import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import WJSON from 'libs/wjson';

const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');
const INDEX_URL = _.get(window, 'VC_CONFIG.INDEX_URL');
const Locale = _.get(window, 'VC_CONFIG.Locale');
const STORE_TYPE_IMAGE_URL_MAP = {
  1: `${PLUGIN_ASSETS_URL}/img/store/storeImage_a.png`,
  2: `${PLUGIN_ASSETS_URL}/img/store/storeImage_s.png`,
};

const getStoreImageUrl = (store) => {
  const storeTypeId = Number(_.get(store, 'store_type_id'));

  return STORE_TYPE_IMAGE_URL_MAP[storeTypeId] || _.get(store, 'images.0', '');
};
// 前端頁面

export default class StoreList extends Component {
  state = {
    data: [], // 分頁
    listInfo: {
      current: 1, //目前頁數
      page_size: 10, //一頁幾筆
      total: 1, //以此query條件，總共幾筆資料
      rows: [],
    },
    query: {
      a: null,
      t: null,
      id: null,
      service_ids: [],
      is24h: null,
    },
    hotKey: [13, 86, 29],
  };
  componentDidMount() {
    const query = AppHelper.getHashParamaters();
    const cacheQuery = WJSON.decode(localStorage.getItem('c4-map-query')) || {
      a: null,
      t: null,
      id: null,
      service_ids: [],
    };
    if (!query.a && cacheQuery.a) {
      query.a = 1;
    }
    localStorage.setItem('c4-map-query', WJSON.encode(query));
    this.loadData(query);
    this.loadConfig();
    this.GTM();
  }
  GTM = () => {
    var dataLayer = window.dataLayer || [];
    $(document).on('click', '#store div a', function() {
      var $text = $(this).attr('alt');
      dataLayer.push({
        event: 'store_click',
        item: $text,
      });
    });
  };
  loadData = (query = {}) => {
    const cacheQuery = WJSON.decode(localStorage.getItem('c4-map-query')) || {
      a: null,
      t: null,
      id: null,
      service_ids: [],
      is24h: null,
    };
    query.a = cacheQuery.a;
    query.t = cacheQuery.t;
    localStorage.setItem('c4-map-query', WJSON.encode(query));

    AppHelper.getStoreList(
      {
        store_type_id: query.t,
        store_area_id: query.a,
        id: query.id,
        service_ids: query.service_ids,
        is24h: query.is24h ? 1 : '',
      },
      () => {
        this.handleInfiniteOnLoad();
      }
    );
  };
  loadConfig = () => {
    this.setState({ isLoadingData: true });

    whttp.get(API_HOST + '/api/v1/system/configs', {}, (state, res) => {
      this.setState({ isLoadingData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      this.setState({ options: data.options });
    });
  };
  refreshPicker = _.debounce(() => {
    const query = _.get(this, 'state.query', {});
    $('.selectpicker[name=id]').selectpicker('val', _.get(query, 'id'));
    $('.selectpicker').selectpicker('refresh');
  }, 1000);
  handleQueryUpdate = (key, value) => {
    const query = _.get(this, 'state.query', {});

    _.set(query, key, value);

    if (key === 'a' || key === 't' || key === 'service_ids') {
      _.set(query, 'id', null);
      $('.selectpicker[name=id]').selectpicker('val', null);
    }
    localStorage.setItem('c4-map-query', WJSON.encode(query));
    this.loadData(query);

    this.setState({ query }, () => {
      this.refreshPicker();
    });
  };
  getSearchPath = (query) => {
    return (
      window.VC_CONFIG.INDEX_URL +
      `/stores/#` +
      qs.stringify(query, { skipNull: true })
    );
  };
  static getDerivedStateFromProps(props, state) {
    const nextListInfo = _.get(props, 'stores.listInfo');
    const prevListInfo = _.get(state, 'listInfo');
    console.log(
      'getDerivedStateFromProps',
      hash(nextListInfo) !== hash(prevListInfo)
    );
    if (hash(nextListInfo) !== hash(prevListInfo)) {
      return {
        data: [],
        listInfo: nextListInfo,
      };
    }
    // Return null to indicate no change to state.
    return null;
  }
  handleInfiniteOnLoad = _.debounce((page) => {
    console.log('handleInfiniteOnLoad');
    const listInfo = _.get(this, 'props.stores.listInfo');
    this.setState({ loading: true });

    const data = _.get(this, 'state.data', []);
    const newData = _.slice(_.get(listInfo, 'rows'), 0, data.length + 3);
    console.log('kkk', newData);
    this.setState({
      loading: false,
      data: newData,
      hasMore: data.length < newData.length,
    });
  }, 100);
  render() {
    // const {listInfo={} } = this.state;
    const listInfo = _.get(this, 'props.stores.listInfo');
    const data = _.get(this, 'state.data');
    const query = _.get(this, 'state.query', {});
    const options = _.get(this, 'state.options', {});
    const hotKey = _.get(this, 'state.hotKey');
    const categoryOptions = _.get(options, 'service_categories', []).filter(
      (categoryInfo) => !_.isEmpty(categoryInfo.items)
    );
    let service_categorys = categoryOptions;
    this.refreshPicker();
    return (
      <main className='bg-light'>
        <div className='container'>
          {/*           
        <div className="d-flex align-items-md-center justify-content-between pt-4">
            <div class="ml-auto" style={{"padding":"20px"}}>
              <Switch
                checkedChildren="24小時營業"
                unCheckedChildren="24小時營業"
                onChange={value=>{
                  if(value===true) query.is24h=1
                  else query.is24h=0
                  this.setState({ query },()=>{
                    this.loadData(query)
                  })
                }}
              />
            </div>
            <a className="p d-inline-block d-md-inline-flex align-items-center text-primary text-decoration-none text-nowrap" 
              role="button" 
              href="javascript:void(0)" 
              data-toggle="modal" 
              data-target="#more-filter">{__('服務篩選','cec-plugin-stores')}
              <span className="rounded-circle text-white bg-primary note line-hight-fit align-items-center justify-content-center ml-2 mb-0 service-filter-count" style={{display:'none',width:'20px',height:'20px'}}>0</span>
              <i className="note icon-plus ml-2"></i>
            </a>
        </div>
        <div className="modal modal-store-service-morefilter fade" id="more-filter" tabindex="-1" role="dialog" aria-labelledby="more-filterTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
            <div className="modal-content">
              <div class="modal-header pl-lg-5 border-primary">
                <div class="d-flex align-items-center justify-content-between flex-fill"><span>&nbsp;</span>
                  <h5 class="p text-primary modal-title mb-0" id="more-filterTitle">{__('請點選下列您所需的服務','cec-plugin-stores')}</h5>
                  <button class="text-navy close m-0" type="button" data-dismiss="modal" aria-label="Close"><span class="text-navy" aria-hidden="true">×</span></button>
                </div>
              </div>
              <div className="modal-body px-lg-5 pb-5">
                <div className="row no-gutters mx-n2" id="item">
                  <h6 class="p text-muted text-center py-3 mb-4 flex-fill w-100 border-gray border-bottom">熱門服務</h6>
                    { _.map(service_categorys, categoryInfo => (
                        _.map(hotKey, key => (
                          _.map(_.get(categoryInfo, 'items', [])
                            .filter(item=>{return key==item.id}), serviceInfo => (
                              <div className="col-auto px-2" >
                                <span className="p btn btn-outline-primary px-3 rounded-pill my-2 service-badge" 
                                      role="button"
                                      id={serviceInfo.id}
                                      onClick={ e => { if(!$(e.target).hasClass('is-active')){
                                                          var temp = this.state.query.service_ids
                                                          var index = temp.findIndex(e => e == serviceInfo.id)
                                                          this.state.query.service_ids.splice(index, 1)
                                                          console.log('is-active',this.state.query.service_ids)
                                                        } else{
                                                          this.state.query.service_ids.push(serviceInfo.id)
                                                          console.log('is-active',this.state.query.service_ids)
                                                        }
                                                      }
                                              } 
                                  >{serviceInfo.name}
                                <a className="close note ml-2" role="button" 
                                    href="javascript:void(0)"> 
                                <i className="icon-close"></i></a></span>
                              </div>
                          ))
                        ))
                      ))
                    }
                  </div>
                { _.map(service_categorys, categoryInfo => (
                  <div className="row no-gutters mx-n2" id="item">
                    <h6 class="p text-muted text-center py-3 mb-4 flex-fill w-100 border-gray border-bottom">{categoryInfo.name}</h6>
                      {_.map(_.get(categoryInfo, 'items', []), serviceInfo => {
                        if(_.find(hotKey,key=>{return key==serviceInfo.id})) return <div></div>
                        else {return(
                          <div className="col-auto px-2" >
                            <span className="p btn btn-outline-primary px-3 rounded-pill my-2 service-badge" 
                                  role="button"
                                  id={serviceInfo.id}
                                  onClick={ e => { if(!$(e.target).hasClass('is-active')){
                                                      var temp = this.state.query.service_ids
                                                      var index = temp.findIndex(e => e == serviceInfo.id)
                                                      this.state.query.service_ids.splice(index, 1)
                                                      console.log('is-active',this.state.query.service_ids)
                                                    } else{
                                                      this.state.query.service_ids.push(serviceInfo.id)
                                                      console.log('is-active',this.state.query.service_ids)
                                                    }
                                                  }
                                          } 
                            >{serviceInfo.name}
                            <a className="close note ml-2" role="button" 
                              href="javascript:void(0)"> 
                            <i className="icon-close"></i></a></span>
                          </div>
                        )}
                      })}
                  </div>
                ))}
              </div>
              <div className="modal-footer border-gray px-lg-5">
                <div className="row align-items-center justify-content-center justify-content-md-between flex-fill">
                  <div className="col-8 col-md-6 ml-md-auto order-md-2">
                    <a className="h6 btn btn-block btn-outline-primary rounded-pill py-4" 
                       role="button" href="#" data-dismiss="modal" aria-label="Close"
                       href={this.getSearchPath(query)}
                       onClick={() => this.loadData(query)}                
                    >{__('確認搜尋','cec-plugin-stores')}</a></div>
                  <div className="col-md-auto text-md-left text-center order-md-1">
                    <p className="p text-primary mb-0 d-inline-flex align-items-center">{__('您已選擇','cec-plugin-stores')}<span className="h5 px-2 mb-0 text-orange line-hight-fit service-filter-count">0</span>{__('種服務','cec-plugin-stores')}<span className="h6 text-gray ml-3 mb-0" role="button" href="#" data-toggle="tooltip" data-placement="top" title="貼心提醒：若選擇太多服務項目，將有可能搜尋不到相應門市，請斟酌您的選擇。"><i className="far fa-question-circle"></i></span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         */}
          <section className='pt-md-5'>
            <InfiniteScroll
              initialLoad={true}
              pageStart={0}
              loadMore={this.handleInfiniteOnLoad}
              hasMore={!this.state.loading && this.state.hasMore}
              // useWindow={false}
            >
              <div id='store' className='row'>
                {_.map(data, (item) => (
                  <div className='col-md-6 col-lg-4 d-flex align-items-stretch'>
                    <div className='card card-storeInfo shadow-0 card-border-width-1 type-1'>
                      <a
                        alt={item.name}
                        className='card-body'
                        role='button'
                        href={`${INDEX_URL}/store-info${
                          Locale == 'en_US' ? '-en' : ''
                        }/?store=${item.name}#tab=info`}>
                        {/* <div
                          className='img-2-1 mb-4'
                          style={{
                            backgroundImage: `url(${_.get(
                              item,
                              'images.0',
                            )})`,
                          }}
                        /> */}
                        <div
                          className='img-2-1 mb-4'
                          style={{
                            backgroundImage: `url(${getStoreImageUrl(item)})`,
                          }}
                        />
                        <h5 className='h4 text-center mb-4'>
                          {(Locale == 'zh_TW' ||
                            (Locale == 'en_US' && !item.en_name)) &&
                            item.name}
                          {Locale == 'en_US' &&
                            item.en_name &&
                            item.en_name}
                          {item.is24h && (
                            <span className='hour-24-tag'>24h</span>
                          )}
                        </h5>
                        <ul className='traffic-info-list'>
                          <li>
                            <i className='icon-store_map' />
                            <span>
                              {(Locale == 'zh_TW' ||
                                (Locale == 'en_US' && !item.en_street)) &&
                                item.address}
                              {Locale == 'en_US' &&
                                item.en_street &&
                                item.en_street}
                              <a
                                className='gMap-link'
                                role='button'
                                href={`https://www.google.com.tw/maps/place/${
                                  item.address
                                }`}
                                target='_blank'>
                                <img
                                  className='ml-3'
                                  src={`${PLUGIN_ASSETS_URL}/img/icon/google_map.svg`}
                                  alt=''
                                />
                              </a>
                            </span>
                          </li>
                          <li>
                            {' '}
                            <i className='icon-store_phone' />
                            <span>
                              <a href={`tel:+886-${item.contact_tel}`}>
                                {item.contact_tel}
                              </a>
                            </span>
                          </li>
                          {/*
                          <li> <i className="icon-store_clock"></i><span>{Locale == "zh_TW" &&  _.isString(_.get(item, 'business_hours', '')) ? _.get(item, 'business_hours', '').substring(0, 40) : ''}
                          {Locale == "en_US" &&  _.isString(_.get(item, 'en_business_hours', '')) ? _.get(item, 'en_business_hours', '').substring(0, 40) : ''}</span></li>
                          */}
                        </ul>
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </InfiniteScroll>
          </section>
        </div>
      </main>
    )
  }
}

// 編輯器
export class StoreListEditor extends Component {
  render() {
    return <div>商店列表</div>;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/stores/store-list-v2.js